<template>
  <el-container class="adm-layout" :style="layoutBgStyle">
    <AdminSidebar />
    <el-container direction="vertical" class="adm-layout__main-wrap">
      <AdminHeader />
      <el-main class="adm-layout__main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AdminSidebar from './AdminSidebar.vue'
import AdminHeader from './AdminHeader.vue'

export default {
  name: 'AdminLayout',
  components: { AdminSidebar, AdminHeader },
  computed: {
    layoutBgStyle() {
      const u = this.base() + 'slices/dashboard/' + encodeURIComponent('page_bg.png')
      return {
        backgroundColor: '#e8f0fb',
        backgroundImage: `url(${u})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: '100% 752px'
      }
    }
  },
  methods: {
    base() {
      return process.env.BASE_URL || '/'
    }
  }
}
</script>

<style lang="scss" scoped>
.adm-layout {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
  background-clip: border-box;
}
.adm-layout__main-wrap {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: transparent;
}
.adm-layout__main {
  padding: 24px 28px 32px;
  flex: 1;
  min-height: 0;
  background: transparent;
}
::v-deep .el-container {
  background: transparent;
}
::v-deep .el-main {
  background: transparent;
}
</style>
